import {Component, Input, OnChanges, OnDestroy, OnInit, Optional, SimpleChanges} from '@angular/core';
import { OutletContextData } from '@spartacus/storefront';
import { Subscription } from 'rxjs';
import {GonvarriCart} from "../../core/models/gonvarri-cart.model";
import {GonvarriCartEntry} from "../../core/models/gonvarri-cart-entry.model";
import {ActiveCartService} from "@spartacus/cart/base/core";
import {OrderSummaryComponent} from "@spartacus/cart/base/components";
import {isAsturias} from "../../utils/check-environment";

@Component({
    selector: 'cx-order-summary',
    templateUrl: './gonvarri-order-summary.component.html',
    styleUrl: './gonvarri-order-summary.component.scss',
    standalone: false
})
export class GonvarriOrderSummaryComponent extends  OrderSummaryComponent implements OnInit, OnDestroy, OnChanges {

  formatter = new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" });

  @Input() override cart: GonvarriCart = {} as GonvarriCart;
  @Input() entries: GonvarriCartEntry[] = [];

  protected override subscription = new Subscription();

  constructor(
    protected activeCartService: ActiveCartService,
    @Optional() protected override outlet?: OutletContextData<any>
  ) {
    super();}

  override ngOnInit(): void {
    if (this.outlet?.context$) {
      this.subscription.add(
        this.outlet.context$.subscribe((context) => {
          this.cart = context;
        })
      );
    }
  }

  override ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngOnChanges(changes: any) {}

  getVoucherData(data: any): any {
    return data;
  }

  showTotalDiscounts(data: any): any {
    return data > 0;
  }

  getTotalWeight(): number {
    return this.entries?.reduce((acc: number, cur: GonvarriCartEntry) => acc + (Number(cur.packageWeight) * Number(cur.quantity)), 0) as number;
  }

  getValueWithoutDiscounts(): number {
    return this.entries?.reduce((acc: number, cur: GonvarriCartEntry) => acc + (Number(cur.totalPrice?.value) ?? 0), 0) as number;
  }

  getValueWithoutDiscountsFormated(): string {
    const formattedValue = "€"+this.formatter.format(this.getValueWithoutDiscounts());
    return formattedValue.slice(0, formattedValue.length-2);
  }

  isOrder(cart: any): boolean {
    const weight = cart?.deliveryOrderGroups?.[0]?.entries?.[0]?.packageWeight;
    console.log(weight);
    return cart?.type === 'orderWsDTO' || cart?.type === 'replenishmentOrderWsDTO';
  }

  getWeightOrder(cart: any): number {
    const weight = cart?.deliveryOrderGroups?.[0]?.entries?.[0]?.packageWeight;
    return weight;
  }

  protected readonly isAsturias = isAsturias;
}
